import IngresseBreadCrumb from './BreadCrumbs/ingresse.breadcrumb';

const breadCrumbsList = [
  { 1 : IngresseBreadCrumb }
];

export default breadCrumbsList;
